<template>
  <b-card class="box">
    <template #header>
      <div class="header-filter">
        <div class="left">
          <b-button variant="outline-secondary" @click.stop="visibleCollapse = !visibleCollapse" size="sm">
            <b-icon icon="filter" aria-hidden="true"></b-icon>
            Bộ lọc
          </b-button>
          <b-button variant="outline-primary" @click="applySearch" size="sm">
            <b-icon icon="search" aria-hidden="true"></b-icon>
            Tìm
          </b-button>
          <b-button variant="outline-danger" @click="clearFilter" size="sm">
            <b-icon icon="x" aria-hidden="true"></b-icon>
            Xóa filter
          </b-button>
          <b-button id="popover-filter-save" variant="outline-success" size="sm" >
            <b-icon icon="star" aria-hidden="true"></b-icon>
            Lưu
          </b-button>
          <b-popover
            target="popover-filter-save"
            triggers="focus"
            :show.sync="popoverSaveShow"
            placement="auto"
            container="my-container"
            ref="popoverSave"
            @show="onShowPopoverEdit"
            >
            <div>
              <span class=" m-b-15">Đặt tên mong muốn</span>
              <div class="m-t-10">
                <input class="col-md-7" type="text" style="height: 40px;" ref="inputSaveFilter" v-model="savingFilterName" @keyup.enter="saveFilter">
                <span class="col-md-1"></span>
                <b-button class="col-md-3"  size="md" variant="primary" :disabled="!savingFilterName.trim()" @click="saveFilter">Lưu</b-button>
              </div>
              <div class=" m-t-10 m-b-10" style="border: 1px solid;"></div>
              
              <ul class="list-preview">
                <li @click="currentIndexEdit = -1" :class="{ active: currentIndexEdit < 0 }">Tạo mới</li>
                <li
                  v-for="(item, index) in manualFilter || []"
                  :key="index"
                  @click="currentIndexEdit = index"
                  :class="{ active: currentIndexEdit === index }"
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
          </b-popover>
          <span class="divider"/>
          
          <span id="popover-filter-list" class="current-filter-name" variant="outline-success" size="sm">
            ▶ {{ currentFilter }}
          </span>
          <b-popover target="popover-filter-list" triggers="click" placement="bottom" :show.sync="popoverFavoriteShow" ref="popoverFavorite">
            <ul class="list-preview">
              <li
                v-for="(item, index) in favoriteFilters || []"
                :key="index"
                @click="onQuickClick(item, index)"
                :class="{ active: currentIndex === index }"
              >
                {{ item.name }}
              </li>
            </ul>
          </b-popover>
        </div>
        <div class="right">
          <div>
            <slot name="header" />
          </div>
          <b-button variant="outline-primary" size="sm" @click="onAddClick">
            <b-icon icon="plus" aria-hidden="true"></b-icon>
            Thêm mới
          </b-button>
        </div>
      </div>
    </template>

    <b-collapse v-model="visibleCollapse" class="mt-2">
      <b-card>
        <b-row>
          <b-col cols="9">
            <div class="w-100">
              <b-button
                v-for="(filter, index) in listFilters"
                variant="outline-secondary" size="sm"
                :key="index"
                @click="addFilter(filter)"
              >
                <b-icon icon="plus" aria-hidden="true"></b-icon>
                {{ filter.field.text }}
              </b-button>
            </div>
            <div class="w-100 mt-3">
              <h3>Điều kiện lọc:</h3>
              <b-row v-for="(item, index) in filters" :key="'filter-row-' + index" class="filter-row">
                <b-col md="1" class="mr-2">
                  <b-form-select v-if="index > 0" v-model="item.prefix" size="sm">
                    <b-form-select-option value=" AND ">AND</b-form-select-option>
                    <b-form-select-option value=" OR ">OR</b-form-select-option>
                  </b-form-select>
                </b-col>
                <b-col md="2">
                  <strong style="line-height: 30px;">{{ item.field.text }}</strong>
                </b-col>
                <b-col md="3" class="mr-2">
                  <b-form-select v-model="item.opr" @change="changeOperator(item)" size="sm">
                    <b-form-select-option
                      v-for="(opr, i) in item.allowedOperators"
                      :key="i"
                      :value="opr"
                    >
                      {{ opr.text }}
                    </b-form-select-option>
                  </b-form-select>
                </b-col>
                <b-col md="4">
                  <slot :name="item.field.code" :item="item">
                    <b-form-input v-model="item.value" :placeholder="item.field.text" size="sm" />
                  </slot>
                </b-col>
                <b-col md="1" class="d-flex align-items-center justify-content-center">
                  <b-button variant="outline-danger" @click="removeFilterCondition(index)" size="sm">
                    <b-icon icon="x" aria-hidden="true"/>
                  </b-button>
                </b-col>
              </b-row>
            </div>
            <div class="w-100 mt-3">
              <h3>Thứ tự sort:</h3>
              <b-row>
                <b-col md="4">
                  <b-form-select v-model="sortField" size="sm">
                    <b-form-select-option v-for="item in sortFields" :key="item.value" :value="item.value">
                      {{ item.label }}
                    </b-form-select-option>
                  </b-form-select>
                </b-col>
                <b-col md="2">
                  <b-form-select v-model="sortType" size="sm">
                    <b-form-select-option value="ASC">Tăng dần</b-form-select-option>
                    <b-form-select-option value="DESC">Giảm dần</b-form-select-option>
                  </b-form-select>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col cols="3">
            <b-card class="favorite-filters box">
              <h3>Tìm kiếm nhanh</h3>
              <b-row no-gutters v-for="(item, index) in favoriteFilters" :key="index">
                <b-col md="8">
                  <b-button variant="link" @click="applyFavoriteFilter(item, index)">
                    {{ item.name }} {{ item.isDefault ? '(default)' : '' }}
                  </b-button>
                </b-col>
                <b-col md="4" class="text-right">
                  <b-button class="btn-custom-active" variant="success" size="sm" @click="setDefaultChange(index)" :class="{ active: index === defaultIndex }">
                    <b-icon icon="check2" aria-hidden="true" />
                  </b-button>
                  <b-button
                    variant="danger"
                    size="sm"
                    @click="removeFavoriteFilter(index)"
                    :disabled="item.isSystem || index === defaultIndex"
                  >
                    <b-icon icon="x" aria-hidden="true" />
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-card>
    </b-collapse>
  </b-card>
</template>

<script>
import { buildQueryStringFromFilter } from '@/utils/querystring';
import { compareObject } from '@/utils/util'
import { Save as saveFeStorage, Detail as detailFeStorage, Remove as removeFeStorage } from '@/services/customer-support/feStorage';

const user = JSON.parse(localStorage.getItem('userData'));

const getKeyStore = (key) => {
  return `${user.userId}.${key}.search`
}

export default {
  name: 'FilterBaseQueryString',
  props: {
    keyStorage: {
      type: String,
    },

    showAddBtn: {
      type: Boolean,
      default: true,
    },

    listDefaultFilter: {
      type: Array,
      default: [],
    },

    listFilters: {
      type: Array,
      default: [],
    },

    sortFields: {
      type: Array,
      default: [],
    },
    onloadDelay: {
      type: Number,
      default: 100,
    }
  },
  data () {
    return {
      visibleCollapse: false,
      filters: [],
      manualFilter: [],
      
      defaultIndex: 0,
      currentIndexEdit: 0,
      currentIndex: 0,
      currentFilter: '...',
      sortField: '',
      sortType: 'ASC',
      meta: {},
      popoverSaveShow: false,
      popoverFavoriteShow: false,
      savingFilterName: '',
      storageFe: {
        selectedIndex: 0,
        filters: []
      },
    }
  },

  computed: {
    favoriteFilters: function() {
      const list = [...(this.listDefaultFilter || []), ...(this.manualFilter || [])];
      return list.map((info, index) => {
        return {
          ...info,
          isDefault: index === this.defaultIndex
        };
      });
    },
  },

  async created() {
  },

  async mounted() {
    await this.getStorage();

    this.makeFilters();
  },

  methods: {
    makeFilters(){
      this.defaultIndex = this.storageFe.selectedIndex;
      this.manualFilter = this.storageFe.filters;

      if (this.favoriteFilters.length > 0) {
        setTimeout(() => {
          if (this.favoriteFilters[this.defaultIndex]) {
            this.applyFavoriteFilter(this.favoriteFilters[this.defaultIndex], this.defaultIndex);
          } else {
            this.applyFavoriteFilter(this.favoriteFilters[0], 0);
          }
        }, this.onloadDelay || 0);
      } else {
        this.sortField = this.sortFields?.length ? this.sortFields[0].value : '';
        this.$emit('search', {
          queryString: '',
          sortField: this.sortField,
          sortType: this.sortType,
          meta: undefined
        });
        this.currentFilter = 'Tất cả';
        this.currentIndex = -1;
      }

      this.$emit('ready', this.favoriteFilters);
    },

    addFilter(filter) {
      this.filters.push({
        ...filter,
        prefix: this.filters.length ? ' AND ' : ''
      })
    },

    changeOperator(item) {
      this.$emit('changeOperator', item);
    },

    removeFilterCondition(index) {
      this.filters.splice(index, 1);
    },

    applySearch(isMeta = false) {
      const queryString = buildQueryStringFromFilter(this.filters);

      this.$emit('search', {
        queryString,
        sortField: this.sortField,
        sortType: this.sortType,
        meta: isMeta ? this.meta : undefined
      });

      this.compareWithSave();
    },

    applyFavoriteFilter(item, index) {
      this.filters = JSON.parse(JSON.stringify(item.conditions));
      this.sortField = item.order.sortField;
      this.sortType = item.order.sortType;
      this.meta = item.meta;
      this.applySearch(true);

      this.currentFilter = item.name;
      this.currentIndex = index;
    },
    
    clearFilter() {
      this.filters = [];
    },

    compareWithSave() {
      const index = this.favoriteFilters.findIndex((favorite) => compareObject(favorite.conditions, this.filters));
      this.currentFilter = index >= 0 ? this.favoriteFilters[index].name : 'Custom';
      this.currentIndex = index;
    },

    async setDefaultChange (index) {
      this.defaultIndex = index;
      await this.saveStorage();
    },
    async removeFavoriteFilter(index) {
      this.manualFilter.splice(index - (this.listDefaultFilter ? this.listDefaultFilter.length : 0), 1);
      await this.saveStorage();
    },

    async saveStorage() {
      try {
        await saveFeStorage(getKeyStore(this.keyStorage), {
          value: {
            selectedIndex: this.defaultIndex,
            filters: this.manualFilter
          }
        });
        this.showSuccessMx('Save done');
      } catch (e) {
        this.showFailMx(e.message);
      }
    },

    onAddClick() {
      this.$emit('addClick');
    },
    onShowPopoverEdit() {
      this.currentIndexEdit = this.currentIndex - (this.listDefaultFilter || []).length;
      this.savingFilterName = this.currentIndex >= 0 ? this.favoriteFilters[this.currentIndex].name || '' : '';

      this.$nextTick(() => {
        this.$refs.inputSaveFilter.focus();
      });
    },
    saveFilter() {
      const savingFilter = {
        name: this.savingFilterName || 'Mặc định',
        conditions: this.filters,
        order: { sortField: this.sortField, sortType: this.sortType },
        isDefault: false,
        isSystem: false,
        meta: this.meta
      };

      if (this.currentIndexEdit < 0) {
        this.manualFilter.push(savingFilter);
      } else {
        this.manualFilter[this.currentIndexEdit] = savingFilter;
      }

      this.popoverSaveShow = false;
      this.saveStorage();
    },
    async getStorage() {
      const res = await detailFeStorage(getKeyStore(this.keyStorage));
      if(res){
        this.storageFe.filters = res.filters ? res.filters : [];
        this.storageFe.selectedIndex = res.selectedIndex ? res.selectedIndex : 0;
      }
    },
    onQuickClick(item, index) {
      this.popoverFavoriteShow = false;
      this.applyFavoriteFilter(item, index);
    },
  },
}

</script>

<style lang="scss" scoped>
.card {
  padding: 5px;
  .card-header {
    margin-bottom: 0 !important;
  }
}

.box {
  border: 1px solid #DDD;
  border-radius: 5px;
}
.btn {
  // cursor: pointer;
  // margin-bottom: 4px;
  & + .btn {
    margin-left: 10px;
  }

  // .b-icon {

  // }
}

.header-filter {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .left {
    display: flex;
    align-items: center;
    .divider {
      margin: 0 10px;
      height: 22px;
      border-left: 2px solid #DDD;
    }
    .current-filter-name {
      cursor: pointer;
      font-weight: 500;
      color: #67c23a;
      font-size: 1.2em;
    }
  }
}

.filter-row {
  margin-bottom: 4px;
}

.btn-custom-active {
  opacity: .4;
  &.active {
    opacity: 1;
    cursor: not-allowed;
    pointer-events: none;
  }
}

ul.list-preview {
  list-style: none;
  padding-left: 0;
  li {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 4px 4px;
    border-radius: 5px;
    &:hover,
    &.active {
      background: #eee;
    }
    &.active {
      font-weight: 500;
      list-style-type: '\1F44D';
    }
    &.no-data {
      cursor: text;
      color: #999;
      &:hover {
        background: #fff;
      }
    }
  }
}
</style>
